import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';

import { StripeAccount } from '../../types/Stripe';

type Props = {
  stripeAccounts: StripeAccount[];
  setSelectedStripeAccountId(value: string): void;
};

const StripeAccountsList = ({
  stripeAccounts,
  setSelectedStripeAccountId,
}: Props) => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Account ID</th>
            <th>Email</th>
            <th>Name</th>
            <th>Date Created</th>
          </tr>
        </thead>
        <tbody>
          {stripeAccounts.map(item => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.email}</td>
              <td>{item.businessName}</td>
              <td>
                {item.created
                  ? moment(item.created).format('MM-DD-YYYY hh:mm:ss')
                  : ''}
              </td>
              <td>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => setSelectedStripeAccountId(item.id)}
                >
                  Associate
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default StripeAccountsList;
